import type { StatusIndicator } from '../../../components/tenant-selector/types';

/** Label substring used to detect tenants with the automation actively on (cannot deselect). */
export const SYNCED_AND_ON_LABEL = 'In Use';

/** Same UI copy for synced-but-off (draft) and other idle states; use `automationStatusesToIndicator` for badge color. */
export const SYNCED_AND_OFF_LABEL = 'Available';

export const HIDDEN_LABEL = 'Hidden';

/**
 * Map backend automation status to the label shown in the Tenants tab.
 */
export function automationStatusToTenantLabel(status: string): string {
  switch (status) {
    case 'archived':
    case 'failed':
      return HIDDEN_LABEL;
    case 'draft':
    case 'completed':
    case 'cancelled':
    case 'partially_cancelled':
      return SYNCED_AND_OFF_LABEL;
    case 'active':
    case 'running':
    case 'sending':
    case 'scheduled':
      return SYNCED_AND_ON_LABEL;
    default:
      return SYNCED_AND_OFF_LABEL;
  }
}

/**
 * Badge color for a tenant row from raw automation statuses. Required because draft and completed
 * both display as {@link SYNCED_AND_OFF_LABEL}.
 */
export function automationStatusesToIndicator(statuses: readonly string[]): StatusIndicator {
  if (statuses.length === 0) return 'neutral';

  let hasHidden = false;
  let hasOn = false;
  let hasDraft = false;

  for (const s of statuses) {
    switch (s) {
      case 'archived':
      case 'failed':
        hasHidden = true;
        break;
      case 'draft':
        hasDraft = true;
        break;
      case 'active':
      case 'running':
      case 'sending':
      case 'scheduled':
        hasOn = true;
        break;
      default:
        break;
    }
  }

  if (hasHidden) return 'hidden';
  if (hasOn) return 'warning';
  if (hasDraft) return 'good';
  return 'neutral';
}
